import { Injectable } from '@angular/core';
import { ComponentRef } from 'react';

@Injectable()
export class CxModalInstance {
  public cxInstance!: ComponentRef<any>;
  public cxRemoveInstance!: () => void;
}
